export default "<div class=\"content-container\">\n  <ng-content></ng-content>\n</div>\n"